import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Element } from 'react-scroll';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../../Ui/Common/InputError';
import SeminarOneFormFieldSubTitle from '../Parts/SeminarOneFormFieldSubTitle';
import SeminarOneFormFieldTitle from '../Parts/SeminarOneFormFieldTitle';
import SeminarOneFormCheckBoxField from './SeminarOneFormCheckBoxField';
const SeminarOneFormCategoriesField = (props) => {
    const { categories, className, disabled, form, name, validate } = props;
    const { error, touched } = useMemo(() => form.getFieldState(name) || {}, [form, name]);
    return (_jsx(Element, Object.assign({ className: className, name: `${name}_view` }, { children: _jsxs("div", Object.assign({ className: 'professional_seminar_one_form_categories' }, { children: [_jsxs("div", Object.assign({ className: 'categories_left' }, { children: [_jsx(SeminarOneFormFieldTitle, { className: 'left_title', text: 'カテゴリー' }), _jsx(SeminarOneFormFieldSubTitle, { className: 'left_sub_title', text: '複数選択可' })] })), _jsxs("div", Object.assign({ className: 'categories_right' }, { children: [_jsx("div", Object.assign({ className: 'right_checkboxes' }, { children: categories.map((v) => (_jsx(SeminarOneFormCheckBoxField, { checkboxLabel: v.name, checkboxValue: v.id, className: 'right_checkbox', disabled: disabled, name: name, validate: validate }, v.id))) })), _jsx(InputError, { className: 'right_error', error: touched && error ? error : '' })] }))] })) })));
};
SeminarOneFormCategoriesField.propTypes = {
    categories: propArrayShape().isRequired,
    className: propStr(),
    disabled: propBool(),
    form: propShape().isRequired,
    name: propStr().isRequired,
    validate: propFunc().isRequired,
};
SeminarOneFormCategoriesField.defaultProps = {
    className: '',
    disabled: false,
};
export default SeminarOneFormCategoriesField;
